import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Trans } from "react-i18next";

export function ErrorFallback() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            maxWidth: 448,
            p: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f00",
            color: "#fff",
            margin: "20px",
          }}
        >
          <Typography variant="h6">
            <Trans>Something went wrong.</Trans>
          </Typography>
          <Typography mb={4}>
            <Trans>Try to solve reloading the page.</Trans>
          </Typography>
          <br />
          <br />
          <Button onClick={handleReload}>
            <Trans>Reload</Trans>
          </Button>
        </Paper>
      </Box>
    </>
  );
}
